import React from "react";
import { TextOqt, TextPropertyName, WrapperComponent } from "../..";

export const FormNodeIterator = ({fmk}) => {
  return (
    <>
      <WrapperComponent caption="Nombre" Field={<TextPropertyName autoFocus name="nombre" formik={fmk} variant="standard"/>}/>
      <WrapperComponent caption="Descripción" Field={<TextOqt name="descripcion" formik={fmk} variant="standard" multiline={true}/>}/>
      <WrapperComponent caption="Campo de iteración" Field={<TextOqt name="campoIteracion" formik={fmk} variant="standard" regExpAccept="^([abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789._])*$" />}/>
    </>
  )
}